<template>
  <div class="otp-wrapper">
    <v-otp-input
      ref="otpInput"
      v-model:value="pin"
      :num-inputs="length"
      :inputType="hidden ? 'password' : 'number'"
      :should-auto-focus="true"
      :should-focus-order="true"
      @on-change="handleChange"
      @on-complete="handleComplete"
      input-classes="otp-input"
      separator=""
    />
  </div>
</template>

<script>
import VOtpInput from "vue3-otp-input";

export default {
  components: {
    VOtpInput,
  },

  props: {
    value: {
      type: String,
      default: "",
    },
    length: {
      type: Number,
      default: 6,
    },
    hidden: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      pin: this.value,
    };
  },

  methods: {
    handleChange(value) {
      this.pin = value;
      this.$emit("typing", value);
    },

    handleComplete(value) {
      this.pin = value;
      this.$emit("complete", value);
    },
  },

  watch: {
    value(val) {
      this.pin = val;
    },
  },
};
</script>

<style scoped>
.otp-wrapper {
  display: flex;
  padding: 18px;
}

.otp-wrapper :deep(div) {
  display: flex;
  width: 100%;
  gap: 8px; 
}

:deep(.otp-input) {
  flex: 1;
  width: 100%;
  min-width: 0;
  height: 50px;

  border: 1px solid #d1d5db;
  border-radius: 0.5rem;
  background: #f5f5f5;

  text-align: center;
  font-size: 1.5rem;
  font-weight: 700;
  color: #374151;
  outline: none;
  transition: border-color .2s, box-shadow .2s;
}

:deep(.otp-input:focus) {
  border-color: #3b82f6;
  box-shadow: 0 0 0 2px rgba(59,130,246,.15);
}
</style>